export const statusesYesOrNo = {
    "true": "да",
    "false": "нет",
}